import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardComponent } from './dashboard/dashboard.component';
import { LayoutComponent } from './layout.component';
import { HeaderComponent } from './header/header.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { FooterComponent } from './footer/footer.component';
import { LayoutRoutingModule } from './layout-routing.module';
import { LetModule, PushModule } from '@ngrx/component';
import { UiModule } from '@piqet-angular/ui';
import { SharedModule } from '@piqet-angular/shared';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ProjectsComponent } from './projects/projects.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ProjectModule } from './projects/projects.module';
import { JoyrideModule } from 'ngx-joyride';
import { MenuService } from '../menu/menu.service';

@NgModule({
  declarations: [
    DashboardComponent,
    LayoutComponent,
    HeaderComponent,
    NavBarComponent,
    FooterComponent,
    MyProfileComponent,
    ProjectsComponent,
  ],
  imports: [
    CommonModule,
    LayoutRoutingModule,
    LetModule,
    PushModule,
    NgSelectModule,
    UiModule,
    SharedModule,
    NgOptionHighlightModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    ProjectModule,
    JoyrideModule.forChild(),
  ],
  providers: [MenuService],
  exports: [LetModule, PushModule, FormsModule, ReactiveFormsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutModule {
  constructor(public menuService: MenuService) {
    // this.menuService.setMenu();
  }
}
